
export interface Shortcut {
    category: string | null;
    id: string;
    description: string;
    icon: string | null;
    enabled: boolean | null;
    order: number;
}

export interface ShortcutRaw {
    enabled: boolean | null;
    id: string;
    items: ShortcutRaw[];
    ord: number;
}

export function toShortcut(e: ShortcutRaw, category: string | null): Shortcut {
    return {
        category: category,
        id: e.id,
        description: e.id,
        icon: null,
        enabled: e.enabled,
        order: e.ord,
    }
}

export interface ShortcutUI extends Shortcut{
    readonly: boolean;
    uncheck: number | null;
}
